module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.d7a0df99.ttf";